module.exports = __webpack_public_path__ + "entry-150bfe9b/finja-struber.256x256-de937309983051e55a0bd939c15993ca.webp";